import {search} from '@sail/icons/react/Icon';
import {Icon, view} from '@sail/ui';
import {defineMessages, FormattedMessage} from 'react-intl';
import {Text} from 'src/v2/components/common';
import {COLORS} from 'src/v2/util/color';

const messages = defineMessages({
  search: {
    id: 'crypto.payins.v2.wallet_select.search',
    description: 'Label for the search item in the wallet select grid',
    defaultMessage: 'Search',
  },
});

export const SearchItem = () => {
  return (
    <view.div
      css={{
        stack: 'y',
        gap: 'small',
        alignX: 'center',
        width: '85px',
        borderRadius: 'small',
        ':hover': {
          backgroundColor: COLORS.offsetHoverOnLight,
        },
        padding: '12px 4px 8px 4px',
      }}
    >
      <view.div
        css={{
          stack: 'x',
          width: '44px',
          height: '44px',
          borderRadius: 'large',
          backgroundColor: COLORS.offsetOnLight,
          alignX: 'center',
          alignY: 'center',
        }}
      >
        <Icon icon={search} size="xsmall" />
      </view.div>
      <Text type="caption" css={{textAlign: 'center'}}>
        <FormattedMessage {...messages.search} />
      </Text>
    </view.div>
  );
};
